exports.formatPhone = (phone) => {
    let formattedPhone = phone.replace(/-/g, "")
    if (formattedPhone.length > 6) {
        formattedPhone = formattedPhone.substr(0, 3) + '-' + formattedPhone.substr(3, 3) + '-' + formattedPhone.substr(6, 4);
    } else if (formattedPhone.length > 3) {
        formattedPhone = formattedPhone.substr(0, 3) + '-' + formattedPhone.substr(3, 3);
    }
    return formattedPhone;
}